const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  roundingMode: "trunc",
});

/**
 * Formats a number as USD currency.
 * @param {number} value
 * @returns {string}
 */
export function formatCurrency(value) {
  return currencyFormatter.format(value);
}
